<template>
  <div class="d-flex flex-grow-1 flex-column">
    <v-breadcrumbs :items="breadcrumbs" class="pa-0 py-2"></v-breadcrumbs>
    <v-row class="flex-grow-0" dense>
      <v-col cols="4">
        <span><strong>Project:</strong>Test Project</span>
      </v-col>
      <v-col cols="6" style="text-align: end;">
        <span><strong>Total windows:</strong>110</span>
      </v-col>
      <v-col cols="2" style="text-align: end;">
        <span><strong>EST Price:</strong> $30,220</span>
      </v-col>
    </v-row>
    <template v-if="schedule && selectedVersion && selectedVersion.URN">
      <WindowViewer
        :modelURN="selectedVersion.URN"
        :viewType="setView"
        :elevationType="setElevation"
        :floorLevel="selectedLevel"
        :selectedWindow="selectedWindowItem"
        :selectedScheduleItems="scheduleItems"
      />
    </template>

    <v-card>
      <v-card-text>
        <div class="d-flex flex-wrap align-center justify-space-between">
          <div class="d-flex align-center">
            <div class="d-flex">
              <h5 class="black--text mr-1">Schedule:</h5>
              <h5>{{ schedule && schedule.name }}</h5>
            </div>
            <template v-if="selectedVersion">
              <v-btn
                outlined
                color="primary"
                class="mx-2"
                height="46"
                depressed
                @click="changeModal = true"
                >Version {{ selectedVersion && selectedVersion.number }}</v-btn
              >
            </template>
            <v-select
              v-model="setView"
              :items="views"
              label="View"
              item-text="text"
              item-value="value"
              :class="setView === '3d view' && 'mr-2'"
              @change="resetElevation"
              dense
              outlined
              hide-details
            ></v-select>
            <v-select
              v-if="setView === '2d view'"
              dense
              :items="elevations"
              v-model="setElevation"
              outlined
              hide-details
              label="Building Elevation"
              class="mx-2"
            ></v-select>
            <v-select
              v-if="setView === '2d geometry'"
              v-model="selectedLevel"
              :items="scheduleLevels"
              item-text="name"
              item-value="name"
              label="Floor Plans"
              class="mx-2"
              @change="setLevel"
              dense
              outlined
              hide-details
            ></v-select>
            <v-btn
              outlined
              depressed
              class=""
              height="46"
              color="primary"
              @click="goToRFQ"
              >RFQ</v-btn
            >
          </div>
          <div>
            <strong class="black--text">Total Estimated Price: $499</strong>
          </div>
        </div>

        <ChangeLog
          v-if="changeModal"
          :dialog="changeModal"
          :versions="versions"
          @onVersionChange="changeVersion"
          @close="changeModal = false"
        />

        <ScheduleList
          :items="scheduleItems"
          :windowItems="scheduleItems"
          :version="selectedVersion"
          @selectedWindow="onItemSelect"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import WindowViewer from "@/components/window/WindowViewer";
import ScheduleList from "@/components/schedule/ScheduleList";
import ChangeLog from "@/components/schedule/ChangeLog";
import { mapState } from "vuex";
export default {
  components: {
    WindowViewer,
    ScheduleList,
    ChangeLog
  },
  created() {
    this.getProjectSchedule();
  },
  computed: {
    ...mapState({
      schItems: store => store.schedule.scheduleItems
    }),
    total_cost() {
      var total = 0.0;
      this.selectedScheduleItems.forEach(item => {
        console.log(item.windowPrice);
        total = total + item.windowPrice;
      });
      return total;
    }
  },
  methods: {
    resetElevation() {
      this.setElevation = null;
    },
    getProjectSchedule() {
      const payload = {
        id: this.$route.params.id,
        name: this.$route.params.name
      };

      this.$store
        .dispatch("schedule/getProjectSchedule", payload)
        .then(resp => {
          this.schedule = { ...resp.schedule };
          this.setVersions();
        });
    },

    setVersions() {
      this.versions = [...this.schedule.versions];
      if (this.versions.length > 0) {
        this.changeVersion(this.versions[0]);
      }
    },

    async changeVersion(version) {
      this.changeModal = false;
      if (
        !this.selectedVersion ||
        version.number.number !== this.selectedVersion.number
      ) {
        this.selectedVersion = { ...version };
        this.getLevels();

        this.getScheduleVersionItems();
      }
    },

    getLevels() {
      const payload = {
        id: this.$route.params.id,
        name: this.$route.params.name,
        version: this.selectedVersion.number
      };

      this.scheduleLevels = [];

      this.$store
        .dispatch(`schedule/getProjectScheduleLevels`, payload)
        .then(resp => {
          this.scheduleLevels = [...resp];
        });
    },

    setLevel(level) {
      this.selectedLevel = level;
      this.scheduleItems = this.schItems.items.filter(
        item => item.level_name === level
      );
    },

    getScheduleVersionItemGroups(payload, allItems) {
      this.$store
        .dispatch(`schedule/getProjectScheduleItemGroups`, payload)
        .then(resp => {
          this.setGroupAndItems(resp.groups, allItems);
        });
    },

    getScheduleVersionItems() {
      const payload = {
        id: this.$route.params.id,
        name: this.$route.params.name,
        version: this.selectedVersion.number
      };

      this.scheduleItems = [];

      this.$store
        .dispatch(`schedule/getProjectScheduleItems`, payload)
        .then(resp => {
          this.scheduleURN = resp.URN;
          this.setItems(resp.items);
        });
    },

    setGroupAndItems(groups, allItems) {
      this.windowItems = [];
      const allGroups = JSON.parse(JSON.stringify(groups));
      let allGroupItems = groups.map(group => group.items);
      allGroupItems = allGroupItems.flat();

      if (
        Array.isArray(groups) &&
        groups.length > 0 &&
        Array.isArray(allItems) &&
        allItems.length > 0
      ) {
        allGroups.forEach((group, gIndex) => {
          let groupItems = [...group.items];
          if (groupItems && groupItems.length > 0) {
            let itemsArray = [];
            groupItems.forEach(groupItem => {
              // Check if item exists in all items
              const item = allItems.find(item => item.id === groupItem);
              if (item) {
                itemsArray.push(item);
              }
            });
            // Replace Group Items ids with item objects
            allGroups[gIndex].items = [...itemsArray];
          }
        });

        // Combine Groups having same config_id
        const combinedGroups = [];
        allGroups.forEach(group => {
          // Check if group already exists in the combined groups
          const configIdGroup = combinedGroups.find((cGroup, cIndex) => {
            if (cGroup.config_id && cGroup.config_id === group.config_id) {
              return {
                index: cIndex,
                group: cGroup
              };
            }

            return null;
          });
          if (configIdGroup && configIdGroup.index) {
            if (combinedGroups[configIdGroup.index].children) {
              combinedGroups[configIdGroup.index].children.push(configIdGroup);
            } else {
              combinedGroups[configIdGroup.index].children = [];
              combinedGroups[configIdGroup.index].children.push(configIdGroup);
            }
          } else {
            combinedGroups.push(group);
          }
        });

        // Get those items that aren't included in the group
        const singleItems = [];
        allItems.forEach(item => {
          const single = allGroupItems.find(gItem => gItem === item.id);
          if (!single) {
            singleItems.push(item);
          }
        });

        // Combine items having same config_id
        const combinedItems = this.setItems(singleItems);
        const allCombinedItems = [...combinedGroups, ...combinedItems];

        this.windowItems = [...allCombinedItems];
      }

      if (!groups.length && allItems.length > 0) {
        this.windowItems = this.setItems(allItems);
      }

      if (this.windowItems && this.windowItems.length > 0) {
        this.adjustGroupAndItemsForDisplay();
      }
    },

    setItems(items) {
      this.scheduleItems = [];
      if (items && items.length > 0) {
        const itemsArray = [];

        // items having config_id
        const configItems = items.filter(item => item.config_id);

        // Non Config Items
        const nonConfigItems = items.filter(item => !item.config_id);

        configItems.forEach(cItem => {
          const existedItem = itemsArray.find(
            item => item.config_id === cItem.config_id
          );

          if (existedItem) {
            if (existedItem.children) {
              existedItem.children.push(cItem);
            } else {
              existedItem.children = [];
              existedItem.children.push(cItem);
            }
          } else {
            itemsArray.push(cItem);
          }
        });

        this.scheduleItems = [...itemsArray, ...nonConfigItems];

      }

    },

    adjustGroupAndItemsForDisplay() {
      const adjustedItems = [];
      let items = JSON.parse(JSON.stringify(this.windowItems));
      // Filter groups that have items in it.
      items = items.filter(
        item => !item.type && item.items && item.items.length > 0
      );

      items.forEach(item => {
        // Only Group Items
        if (!item.type && item.items && item.items.length > 0) {
          // Get first item from group items.
          const firstItem = item.items.shift();
          // Make other items as children of first item
          if (item.items.length > 0) {
            // Remove first item and make other items as child of first item.
            // const childItems = item.items.shift();
            firstItem.children = [...item.items];
          }

          adjustedItems.push(firstItem);
        }
      });

      // Remove group items from window items and concat it with adjusted items.
      const singleItems = this.windowItems.filter(
        item => item.type === "single_item"
      );

      this.windowItems = [...adjustedItems, ...singleItems];

      console.log("FINAL ITEMS: ", this.windowItems);
    },

    onItemSelect(item) {
      this.selectedWindowItem = { ...item };
    },

    goToRFQ() {
      this.$router.push(
        `/rfq/project/${this.$route.params.id}/schedule/${this.$route.params.name}`
      );
    }
  },
  data() {
    return {
      schedule: null,
      scheduleURN: null,
      scheduleLevels: [],
      scheduleItems: [],
      windowItems: [],
      selectedWindowItem: null,
      changeModal: false,
      searchText: "",
      numitems: 0,
      is3d: "block",
      is2d: "none",
      is22d: "none",
      views: [
        { text: "Floor Plan", value: "2d geometry" },
        { text: "3D", value: "3d view" },
        { text: "Elevation", value: "2d view" }
      ],
      floors: [], // ["Level 1", "Level 2", "Level 3", "Level 4"],
      elevations: ["North", "South", "East", "West"],
      setElevation: "",
      setView: "3d view", //initialize the view with 3d view
      setFloor: "",
      tab: null,
      URN: null,
      columnValues: [],
      selectedScheduleItems: [],
      selectedVersion: null,
      selectedLevel: null,
      versions: [],
      version: null,
      columns: ["Mark", "Width", "Height"],
      searchString: "",
      breadcrumbs: [
        {
          text: "Projects",
          to: "/"
        },
        {
          text: "Project Details",
          disabled: true
        }
      ]
    };
  }
};
</script>
